module.exports = __webpack_public_path__ + "static/media/acoustic-ukulele.95698692.mp3";